// @flow
import getEndpointUrl from 'api/getEndpointUrl';
import checkResponse from 'api/checkIfResponseIsOK';
import wrapWithNetworkError from 'api/wrapWithNetworkError';
import LRU from 'lru-cache';

const cache = LRU({ max: 10 });

export const createProfileFetcher = (resource: string) => {
  return wrapWithNetworkError((token: string, clientId: Id) => {
    const cacheKey = `${resource}/${clientId}`;
    // check cache
    if (cache.has(cacheKey)) {
      const data = cache.get(cacheKey);
      if (data) return Promise.resolve(data);
    }

    const fetchUrl = getEndpointUrl(`/merchantGroup/${clientId}/${resource}`);
    const fetchOptions = {
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        Authorization: token,
      },
    };

    return fetch(fetchUrl, fetchOptions)
      .then(response => checkResponse(response))
      .then(response => response.json())
      .then(response => {
        cache.set(cacheKey, response);
        return response;
      });
  });
};

export const getUserProfiles = createProfileFetcher('profile');
export const getExpertUserProfiles = createProfileFetcher('expertUserProfile');



// WEBPACK FOOTER //
// ./src/containers/client/userProfilesApi.js